/* global window */
import inDOM from 'dom-helpers/util/inDOM';
import { TRACK_EVENT } from '../actions';

if (inDOM && !window.dataLayer) {
  window.dataLayer = [];
}

export default () => next => reduxAction => {
  if (inDOM && reduxAction.type === TRACK_EVENT) {
    const {
      event,
      category,
      action,
      label,
    } = reduxAction.payload;
    const hasEventData = !!(category || action || label);
    if (event || hasEventData) {
      const props = {
        event: event || process.env.REACT_APP_DEFAULT_GTM_EVENT || 'ga.event.prismic',
      };
      if (hasEventData) {
        props.eventData = {
          category,
          action,
          label,
        };
      }
      window.dataLayer.push(props);
    }
  }
  return next(reduxAction);
};
